import { Box, TextField } from "@mui/material";
import { useTranslation } from "@refinedev/core";
import { Edit, useAutocomplete } from "@refinedev/mui";
import { useForm } from "@refinedev/react-hook-form";

export const FarmerEdit = () => {
  const { translate } = useTranslation();

  const {
    saveButtonProps,
    refineCore: { queryResult },
    register,
    control,
    formState: { errors },
  } = useForm();

  const farmersData = queryResult?.data?.data;

  const { autocompleteProps: produitsAutocompleteProps } = useAutocomplete({
    resource: "produits",
    defaultValue: farmersData?.produits,
  });

  const { autocompleteProps: insAutocompleteProps } = useAutocomplete({
    resource: "ins",
    defaultValue: farmersData?.ins,
  });

  const { autocompleteProps: outsAutocompleteProps } = useAutocomplete({
    resource: "outs",
    defaultValue: farmersData?.outs,
  });

  return (
    <Edit saveButtonProps={saveButtonProps}>
      <Box
        component="form"
        sx={{ display: "flex", flexDirection: "column" }}
        autoComplete="off"
      >
        <TextField
          {...register("name", {
            required: translate('this-field-is-required'),
          })}
          error={!!(errors as any)?.name}
          helperText={(errors as any)?.name?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="text"
          label="Name"
          name="name"
        />
        <TextField
          {...register("phone", {
            required: translate('this-field-is-required'),
            valueAsNumber: true,
          })}
          error={!!(errors as any)?.phone}
          helperText={(errors as any)?.phone?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="number"
          label="Phone"
          name="phone"
        />
        <TextField
          {...register("code", {
            required: translate('this-field-is-required'),
            valueAsNumber: true,
          })}
          error={!!(errors as any)?.code}
          helperText={(errors as any)?.code?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="number"
          label="Code"
          name="code"
        />
        {/*
                    DatePicker component is not included in "@refinedev/mui" package.
                    To use a <DatePicker> component, you can follow the official documentation for Material UI.

                    Docs: https://mui.com/x/react-date-pickers/date-picker/#basic-usage
                */}
        <TextField
          {...register("createdAt", {
            required: translate('this-field-is-required'),
          })}
          error={!!(errors as any)?.createdAt}
          helperText={(errors as any)?.createdAt?.message}
          margin="normal"
          fullWidth
          disabled
          InputLabelProps={{ shrink: true }}
          label="Created At"
          name="createdAt"
        />
      </Box>
    </Edit>
  );
};
